

import Vue from "vue";
import { SaleService } from "../../services/sale-service";
import { Sale } from "../../models/base";
import { SaleLayoutConf } from "@/models/sale-layout";
import AppPdfViewer from "@/components/common/PdfViewer.vue";
import { PdfImages } from "@/utils/pdf-images";
import { PrintContext, SalePrintSettings } from "@/utils/sale-layouts/print-settings";

export default Vue.extend({
	data() {
		return {
			fetching: false,
			shouldFetchAsImage: null as null | boolean,
			blob: null as null | Blob,
			images: null as null | PdfImages
		};
	},
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		},
		layout: {
			type: Object as () => SaleLayoutConf,
			required: true
		},
		load: Boolean
	},
	watch: {
		load: {
			immediate: true,
			handler(){
				if (this.fetching) return;
				if (this.shouldFetchAsImage === null) return;
				if (!this.load) return;
				this.preview();
			}
		},
		shouldFetchAsImage: {
			handler(){
				if (this.fetching) return;
				if (this.shouldFetchAsImage === null) return;
				if (!this.load) return;
				this.preview();
			}
		}
	},
	methods: {
		async preview() {
			if (this.images || this.blob) return;
			if (this.shouldFetchAsImage === null) return;
			this.fetching = true;
			if (this.shouldFetchAsImage) {
				this.images = await SaleService.downloadSaleAsImages(this.sale, this.layout.ID, new SalePrintSettings(PrintContext.PRINT));
			}else{
				this.blob = await SaleService.downloadSale(this.sale, this.layout.ID, new SalePrintSettings(PrintContext.DOWNLOAD));
			}
			this.fetching = false;
		}
	},
	components: {
		AppPdfViewer
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
